/**
 * Typisierte Fehler-Hierarchie (vibe-grundlagen/principles/error-handling.md).
 *
 * Jeder Fehler hat zwei Gesichter:
 *   - `message`  → geht als User-Meldung raus (verstaendlich, ohne Technik)
 *   - `detail`   → landet nur im Log (technischer Kontext, nie in der Response)
 *
 * Der globale Fastify-Error-Handler (packages/api/src/plugins/error-handler.ts)
 * mappt diese Klassen auf den Response-Envelope aus ADR 0001.
 */
/** Maschinenlesbare Fehler-Codes — englisch (ADR 0004). */
export const ERROR_CODES = [
    'VALIDATION_ERROR',
    'NOT_FOUND',
    'UNAUTHORIZED',
    'FORBIDDEN',
    'CONFLICT',
    'RATE_LIMITED',
    'CSRF_ERROR',
    'SERVICE_UNAVAILABLE',
    'INTERNAL_ERROR',
];
/** Basisklasse. Nie direkt werfen — immer eine der Unterklassen benutzen. */
export class AppError extends Error {
    /** Technischer Kontext — ausschliesslich fuer Logs, nie fuer den Client. */
    detail;
    constructor(message, detail) {
        super(message);
        this.name = new.target.name;
        this.detail = detail;
    }
}
/** 4xx — der Aufrufer ist schuld. Kein Retry, Log-Level `warn`. */
export class UserError extends AppError {
    logLevel = 'warn';
}
export class ValidationError extends UserError {
    code = 'VALIDATION_ERROR';
    status = 422;
}
export class NotFoundError extends UserError {
    code = 'NOT_FOUND';
    status = 404;
}
export class UnauthorizedError extends UserError {
    code = 'UNAUTHORIZED';
    status = 401;
}
export class ForbiddenError extends UserError {
    code = 'FORBIDDEN';
    status = 403;
}
export class ConflictError extends UserError {
    code = 'CONFLICT';
    status = 409;
}
export class RateLimitError extends UserError {
    code = 'RATE_LIMITED';
    status = 429;
}
export class CsrfError extends UserError {
    code = 'CSRF_ERROR';
    status = 403;
}
/** Ein externer Dienst ist schuld (Mailprovider, KI-Provider, SkillLock). */
export class ExternalError extends AppError {
    code = 'SERVICE_UNAVAILABLE';
    status = 503;
    logLevel = 'error';
}
/** 5xx — wir sind schuld. Der Client bekommt nur eine generische Meldung. */
export class SystemError extends AppError {
    code = 'INTERNAL_ERROR';
    status = 500;
    logLevel = 'error';
}
export function isAppError(value) {
    return value instanceof AppError;
}
/** Generische User-Meldung fuer alles, was kein AppError ist. */
export const INTERNAL_ERROR_MESSAGE = 'Ein interner Fehler ist aufgetreten. Bitte versuche es später erneut.';
//# sourceMappingURL=errors.js.map